/*
 * fn: parseComboPreviewResponse
 *
 * Parses a combo preview response into a front end object
 *
 */
import { type CardListType } from '@/defs/apiLegacy/pagePartsResponse'
import { type ComboPreviewType } from '@/defs/combo'
import { getCardRef, getColorId } from '@/utils/cardUtil'
import { isNonEmptyString } from '@/utils/commonUtil'

import { formatComboResult } from './formatComboResult'
import { getComboBracketInfo } from './getComboBracketInfo'

type Props = {
  cardList: CardListType
}

export const parseComboPreviewResponse = ({ cardList }: Props): ComboPreviewType | false => {
  const cards = cardList.cardviews
    ?.filter((card): card is { name: string; sanitized?: string } => isNonEmptyString(card.name))
    .map((cardview) =>
      getCardRef({
        name: cardview.name,
        slug: cardview.sanitized,
      }),
    )
  const id = cardList.combo?.comboId
  const results = cardList.combo?.results?.map((r) => formatComboResult(r))

  if (!cards || cards.length < 2) return false
  if (!id) return false
  if (!results || results.length < 1) return false

  const comboBase = {
    cards,
    id,
    numDecks: cardList.combo?.count || 0,
    potentialDecks: cardList.combo?.maxCount || 0,
    rank: cardList.combo?.rank || 0,
    results,
    vote: cardList.combo?.comboVote,
  }

  const bracketInfo = getComboBracketInfo({ comboBase })

  return {
    ...comboBase,
    bracketInfo,
    colorId: getColorId(cardList.combo?.colors?.split('')),
    nonCardPrerequisiteCount: cardList.combo?.nonCardPrerequisiteCount || 0,
  }
}
